import React, {FC} from 'react'

import {TrackAppEvent} from 'src/lib/Analytics/analytics_compat'
import {AppEvents} from 'src/lib/Analytics/app_events'
import {usePageViewedAnalytics} from 'src/lib/Analytics/usePageViewedAnalytics'
import {logErrorAndShowException} from 'src/lib/errors'
import {ProhibitedBusinessMethodsGQLContainer} from 'src/products/general/ProhibitedBusinessMethods/ProhibitedBusinessMethodsGQLContainer'
import {WorkflowPreReqFulfillScreenProps} from 'src/workflows/types'

export const ProhibitedBusinessMethodsWorkflowContainer: FC<WorkflowPreReqFulfillScreenProps> = ({
  onPreReqFulfilled,
}) => {
  usePageViewedAnalytics({
    eventName: AppEvents.Name.prohibited_business_methods_screen_viewed,
    eventCategory: AppEvents.Category.Onboarding,
  })

  const handleComplete = async (): Promise<void> => {
    try {
      TrackAppEvent(
        AppEvents.Name.prohibited_business_methods_screen_completed,
        AppEvents.Category.Onboarding,
      )
      await onPreReqFulfilled()
    } catch (error) {
      void logErrorAndShowException(error, 'Error submitting Prohibited Business Methods')
    }
  }

  return <ProhibitedBusinessMethodsGQLContainer onComplete={handleComplete} />
}
